import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { contactService } from '../../services/contactService'
import { GET_CONTACTS_WITH_MULTIPLE_PARTNER_DATA } from '../config'
import { IContactsWithMultiplePartnersParams } from '../models'
import { selectContactsWithMultiplePartnersLoadingStatus } from '../selectors/selectCommonData'

import { handleApiResponse } from './helpers/handleApiResponse'

class ContactApi {
  public getContactsWithMultiplePartners = createAsyncThunk(
    GET_CONTACTS_WITH_MULTIPLE_PARTNER_DATA,
    async ({ requestId }: IContactsWithMultiplePartnersParams, _thunkAPI) => {
      const response = await contactService.getContactsWithMultiplePartners(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectContactsWithMultiplePartnersLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const contactApi = new ContactApi()
